import { FiX } from "react-icons/fi";
import { useEffect, useState } from "react";

const BarcodeViewModal = ({ selectedImage, onClose }) => {
  const [src, setSrc] = useState("");

  useEffect(() => {
    if (!selectedImage) {
      setSrc("");
      return;
    }
    if (typeof selectedImage === "string") {
      setSrc(selectedImage);
    } else if (selectedImage instanceof File) {
      const objectUrl = URL.createObjectURL(selectedImage);
      setSrc(objectUrl);
      return () => URL.revokeObjectURL(objectUrl);
    }
  }, [selectedImage]);

  if (!src) return null;

  return (
    <div className="relative">
      <button
        onClick={onClose}
        className="absolute top-[-15px] right-[-15px] text-black bg-[#E2E2E2] rounded-full hover:text-gray-900"
      >
        <FiX size={24} />
      </button>
      <img src={src} alt="Barcode" className="w-full h-auto rounded" />
    </div>
  );
};

export default BarcodeViewModal;
